import React, { useState } from "react";
import "../Component/Component.css/VillageForm.css";
import village from "../Images/village.jpg";
import emailjs from "@emailjs/browser";

export default function VillageForm() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus("");

    try {
      await sendEmailWithEmailJS();
      setSubmitStatus("success");
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
      });
    } catch (error) {
      console.error("Error sending email:", error);
      
      if (error.text?.includes('service ID not found')) {
        setSubmitStatus("service_not_found");
      } else if (error.text?.includes('Public Key')) {
        setSubmitStatus("invalid_key");
      } else {
        setSubmitStatus("error");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const sendEmailWithEmailJS = async () => {
    // सर्व माहिती एकाच templateParams मध्ये ठेवा
    const templateParams = {
      from_name: `${formData.firstName} ${formData.lastName}`,
      name: `${formData.firstName} ${formData.lastName}`,
      email: formData.email,
      phone: formData.phone,
      message: formData.message,
      time: new Date().toLocaleString(),
      to_email: "info@grampanchayatnagthane.in",
      reply_to: formData.email,
      subject: `New Message from ${formData.firstName} ${formData.lastName} - Gram Panchayat Nagthane`,
    };

    // ✅ EmailJS Credentials
    const serviceID = "service_9832ngu"; 
    const templateID = "template_qwxkimg";
    const publicKey = "B3IpNzeRsF-enX9zr";

    console.log("Attempting to send email...", templateParams);
    const response = await emailjs.send(serviceID, templateID, templateParams, publicKey);
    console.log("Email sent successfully!", response);
    return response;
  };

  return (
    <div className="village-container">
      <img src={village} alt="Village Background" className="bg-image" />

      <div className="content">
        <div className="header-text">
          <h1>आपला सहयोग, आमची प्रगती</h1>
          <h2>चला एकत्र येऊन आपल्या गावाचं उज्ज्वल भविष्य घडवूया!</h2>
        </div>

        <form className="form-box" onSubmit={handleSubmit}>
          <div className="row">
            <div className="field">
              <label>नाव</label>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                placeholder=" "
                required
              />
            </div>

            <div className="field">
              <label>आडनाव</label>
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                placeholder=" "
                required
              />
            </div>
          </div>

          <div className="row">
            <div className="field">
              <label>ईमेल</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder=" "
                required
              />
            </div>

            <div className="field">
              <label>संपर्क क्रमांक</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder=" "
                required
              />
            </div>
          </div>

          <div className="field message-field">
            <label>आपला संदेश</label>
            <textarea
              rows="3"
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="तुमचा संदेश लिहा..."
              required
            ></textarea>
          </div>

          {submitStatus === "success" && (
            <div className="status-message success">
              धन्यवाद! आपला संदेश यशस्वीरित्या पाठवला गेला आहे.
            </div>
          )}

          {submitStatus === "error" && (
            <div className="status-message error">
              क्षमस्व! संदेश पाठवताना त्रुटी आली. कृपया पुन्हा प्रयत्न करा.
            </div>
          )}

          <button type="submit" className="submit-btn" disabled={isSubmitting}>
            {isSubmitting ? "पाठवत आहे..." : "सबमिट करा"}
          </button>
        </form>
      </div>
    </div>
  );
}